import { Mark, mergeAttributes, markInputRule, markPasteRule } from '@tiptap/core';

const starInputRegex = /(?:^|\s)((?:\*)((?:[^*]+))(?:\*))$/gm;
const starPasteRegex = /(?:^|\s)((?:\*)((?:[^*]+))(?:\*))/gm;
const underscoreInputRegex = /(?:^|\s)((?:_)((?:[^_]+))(?:_))$/gm;
const underscorePasteRegex = /(?:^|\s)((?:_)((?:[^_]+))(?:_))/gm;
const Italic = Mark.create({
    name: 'italic',
    defaultOptions: {
        HTMLAttributes: {},
    },
    parseHTML() {
        return [
            {
                tag: 'em',
            },
            {
                tag: 'i',
                getAttrs: node => node.style.fontStyle !== 'normal' && null,
            },
            {
                style: 'font-style=italic',
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['em', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            /**
             * Set an italic mark
             */
            setItalic: () => ({ commands }) => {
                return commands.setMark('italic');
            },
            /**
             * Toggle an italic mark
             */
            toggleItalic: () => ({ commands }) => {
                return commands.toggleMark('italic');
            },
            /**
             * Unset an italic mark
             */
            unsetItalic: () => ({ commands }) => {
                return commands.unsetMark('italic');
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-i': () => this.editor.commands.toggleItalic(),
        };
    },
    addInputRules() {
        return [
            markInputRule(starInputRegex, this.type),
            markInputRule(underscoreInputRegex, this.type),
        ];
    },
    addPasteRules() {
        return [
            markPasteRule(starPasteRegex, this.type),
            markPasteRule(underscorePasteRegex, this.type),
        ];
    },
});

export default Italic;
export { Italic, starInputRegex, starPasteRegex, underscoreInputRegex, underscorePasteRegex };
//# sourceMappingURL=tiptap-extension-italic.esm.js.map
